import React  from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem ,} from 'reactstrap';
import {Form, FormGroup, Col, Label, Input, FormText} from 'reactstrap'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import AppBar from 'material-ui/AppBar';
import RaisedButton from 'material-ui/RaisedButton';
import './SelectCameraStyle.css';
import axios from 'axios'
import {getServerHost} from '../../utils';
import {config,}  from '../../config'
import Logout from '../Login/Logout'
import {getCookie} from "../../utils/utils"



const buildURL = (endpoint: string) => {
  const serverHost = getServerHost();
  return `${serverHost}${config.baseAPIURI}${endpoint}`;
};

// Storing Selected camId on localStorage
const STORE_SELECTED_CAM = (camId: string, camLabel: string) => {
  if (camId){
    console.log("Store Selected CamId", camId);
    window.localStorage.setItem("camId", camId);
    window.localStorage.setItem("camLabel", camLabel);
  }
}
type myProps = {
    

};

type myState = { 
              showAddcameraPopup: boolean,
              showSelectCameraPopup: boolean, 
              selectCameraDropdown: boolean,
              cameraList: string[]
              getSelectedCamera: string
              submitButtonText: JSX.Element
              };

class SelectCamera extends React.Component<myProps, myState> {
constructor(props: any){
  super(props);
  this.state={
    cameraList: [],
    getSelectedCamera: "",
    showAddcameraPopup: false,
    showSelectCameraPopup: false,
    selectCameraDropdown: false,
    submitButtonText: (<span>Add</span>),
  }
 }

render() {
  const selectCameraDropdownItems = [];
  for (let i=0; i<this.state.cameraList.length || 0; i++){
    selectCameraDropdownItems.push(
                                <DropdownItem className = "camera-label" 
                                  onClick={() => {
                                    STORE_SELECTED_CAM(this.state.cameraList[i]["id"], this.state.cameraList[i]["label"]);
                                   //return( <Redirect to={'/violationsHistory'} push/>)
                                    window.location.href='./eventsHistory'
                                  }}
                                >
                                  {this.state.cameraList[i]["label"]}
                                      
                                </DropdownItem>)
  }
 
    return (
      <div>
        <MuiThemeProvider>
          <div>
            <AppBar className="appbar" title="List of Cameras" style={{zIndex:1, margin:'none'}} >
              <h4><Logout show={true} /> </h4>
            </AppBar>
            <br/>
            <RaisedButton className="main-button"label="Select Camera" primary={true} style={style} onClick={(event) => this.selectCameraClick(event)}/>
            <Modal
              show={this.state.showSelectCameraPopup}
              onHide ={() => this.setState({showSelectCameraPopup:false})}  
            >
        
              <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                  Select Camera
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Dropdown direction="right" isOpen={this.state.selectCameraDropdown} toggle = {() => this.selectCameraDropdownToggle()}>
                  <DropdownToggle caret>
                    Choose  Camera
                  </DropdownToggle>
                  <DropdownMenu
                    down
                    title="Dropdown right"
                    id="dropdown-menu-align-right"
                  >
                      <Col sm={6}>{selectCameraDropdownItems}</Col>
                      

                  </DropdownMenu>
                </Dropdown>
                
                


              </Modal.Body>
              <Modal.Footer>
                <Button onClick={() => this.setState({showSelectCameraPopup:false})}>Close</Button>
              </Modal.Footer>
          </Modal>
            <br/>
            <RaisedButton className="main-button" label="Add Camera" primary={true} style={style} onClick={(event) => this.addCameraClick(event)}/>
            <Modal
              show={this.state.showAddcameraPopup}
              onHide ={() => this.setState({showAddcameraPopup:false})}  
            >
        
              <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                  <h2>Add Camera</h2>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
              <Form onSubmit = {(event)=> this.handleSubmitAddCamera(event)}>
                <FormGroup row>
                  <Label for="camLabel" sm={2}>Camera Label</Label>
                  <Col sm={10}>
                    <Input  type = "text" defaultValue = "" name="Label" id="camLabel" placeholder="Mall Road Camera" />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label for="camId" sm={2}>Camera ID</Label>
                  <Col sm={10}>
                    <Input  type = "text" defaultValue = "" name="Id" id="camId" placeholder="2019112700035.mp4" />
                  </Col>
                </FormGroup>
                
                <FormGroup row>
                  <Label for="exampleText" sm={2}>Discription</Label>
                  <Col sm={10}>
                    <Input type="textarea" name="text" id="exampleText" />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label for="exampleFile" sm={2}>File</Label>
                  <Col sm={10}>
                    <Input defaultValue = "" type="file" name="file" id="exampleFile" />
                    <FormText color="muted">
                      Select XML or .csv file containing cameras' list.
                    </FormText>
                  </Col>
                </FormGroup>               
                <FormGroup check row>
                  <Col sm={{ size: 10, offset: 2 }}>
    <Button className = "submitButton"  type="submit">{this.state.submitButtonText}</Button>
                  </Col>
                </FormGroup>
           </Form>
              </Modal.Body>
              <Modal.Footer>              
                <Button onClick={() => this.setState({showAddcameraPopup:false})}>Close</Button>
              
              </Modal.Footer>
          </Modal>
         
          </div>
        </MuiThemeProvider>
           
      </div>
    );
  }
handleSubmitAddCamera(event: any){
  const token = getCookie("auth_token")
  const that = this;
  event.preventDefault();
  if(event.target.Label.value && event.target.Id.value){
    const endpoint = `/camera-list`
    const data = {
      'label': event.target.Label.value,
      'id': event.target.Id.value
    };
    const url = buildURL(endpoint);
    axios.put(url, data, { headers: {"Authorization" : `Bearer ${token}`} })
    .then(function (response) {
      if(response.request.status===200){
        that.setState({submitButtonText: <span>Added&#10003;</span>});
      }
  })
    .catch(function (error) {
      that.setState({submitButtonText: <span>Request Failed</span>});
    });
  }
}
selectCameraDropdownToggle(){
  if(this.state.selectCameraDropdown)
    this.setState({selectCameraDropdown: false});
  else
    this.setState({selectCameraDropdown: true});
}
selectCameraClick(event: any){
  const that = this;
  this.setState({showSelectCameraPopup: true}); 
  const endpoint = `${config.serverHost}${config.baseAPIURI}/camera-list`;
  const token = getCookie("auth_token");
  axios.get(endpoint, { headers: {"Authorization" : `Bearer ${token}`} })
  .then(function (response) {
    that.setState({cameraList: response.data.result||[]})
  })
  .catch(function (error) {
    console.log(error);
  });
};
addCameraClick(event: any){
  this.setState({showAddcameraPopup: true}); 
  this.setState({submitButtonText: <span>Add</span>})
};

};

const style = {
  width: 200,
  height: 50,
  margin: 25,
};

export default SelectCamera;



// WEBPACK FOOTER //
// ./src/components/SelectCamera/SelectCamera.tsx